import { useGetProvinceName } from '@b-stock/fe-core/bstock-next/hooks'

/**
 * Builds the buyer-facing location label used on listing cards.
 * US listings render as `City, ST`; international listings expand the province
 * to its full name (when known) and append the country code.
 */
export const useCardLocation = ({
  city,
  provinceCode,
  countryCode,
}: {
  city?: string
  provinceCode?: string
  countryCode?: string
}): string => {
  const getProvinceName = useGetProvinceName(countryCode)
  let parts = []

  if (countryCode === 'US') {
    parts = [city, provinceCode]
  } else {
    const provinceName = getProvinceName(provinceCode)
    parts = [city, provinceName, countryCode]
  }

  return parts.filter(Boolean).join(', ')
}
